<template>
  <div class="bg-white rounded-[8px] p-[15px] border border-gray-100">
    <div class="h-8 flex flex-row items-center justify-between gap-3">
      <span class="text-base leading-6 font-semibold text-gray-800 truncate">
        {{ app.title }}
      </span>
      <span class="flex flex-row gap-[5px]">
        <button-v2
          v-if="hasEditPermission('External Dashboard')"
          variant="ghost"
          size="sm"
          icon="edit"
          :aria-label="
            $t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.UPDATE.HEADER')
          "
          @click="$emit('edit', app)"
        />
        <button-v2
          v-if="hasDeletePermission('External Dashboard')"
          variant="ghost"
          color="danger"
          size="sm"
          icon="delete"
          :aria-label="
            $t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.DELETE.TITLE')
          "
          @click="$emit('delete', app)"
        />
      </span>
    </div>

    <copy-field-v2 class="mt-5" compact :value="url" />
  </div>
</template>

<script>
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  name: 'ExternalDashboardCard',
  mixins: [hasPermissionMixin],
  props: {
    app: {
      type: Object,
      required: true,
    },
  },
  computed: {
    url() {
      return this.app.content?.[0]?.url || '';
    },
  },
};
</script>
